module.exports = __webpack_public_path__ + "media/img/apple-icon-152x152-32e3832633a6f91e2dc8b5ac70427d7a.png";